module.exports = __webpack_public_path__ + "img/edit.99e7f254.svg";